import * as React from 'react';
import {CircularProgress} from "@/component/view/CircularProgress";
import {ErrorUtil} from "@/utils/ErrorUtil";

interface Props<T> {
    data: T | undefined;
    error: any | undefined | null;
    component: (data: T) => React.ReactNode;
}

export function LoadableView<T>(props: Props<T>) {
    const {data, error, component} = props;

    if (error !== undefined && error !== null) {
        const errorMessage = (typeof error === 'string') ? error : ErrorUtil.getErrorMessage(error);
        return <div style={{color: 'red'}}>Error: {errorMessage}</div>;
    } else if (!data) {
        return <div><CircularProgress/></div>;
    } else {
        return <>{component(data)}</>;
    }
}